import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="flex min-h-dvh flex-col bg-brand-piedra text-text-primary">
      <header className="flex items-center justify-between px-8 py-6 font-mono text-[11px] tracking-widest text-brand-red md:px-12 md:py-8 lg:px-14 lg:py-10 lg:text-[13px]">
        <span>● RESERVAS V1.0</span>
        <span>ERR · 404</span>
      </header>

      <main className="flex flex-1 flex-col items-center justify-center px-8 text-center md:px-12">
        <p className="font-serif text-[180px] font-normal italic leading-none tracking-[-0.04em] text-brand-red md:text-[240px] lg:text-[300px]">
          404
        </p>
        <h1 className="mt-6 font-serif text-3xl italic tracking-tight md:text-4xl">
          Esta página no está en la carta.
        </h1>
        <p className="mt-3 max-w-md text-sm text-text-secondary md:text-base">
          La ruta que buscas no existe o cambió de lugar. Vuelve al inicio para continuar.
        </p>

        <Button asChild size="xl" className="mt-10">
          <Link to="/">Volver al inicio</Link>
        </Button>
      </main>

      <footer className="flex items-baseline justify-between border-t border-brand-red/40 px-8 py-6 font-mono text-[11px] uppercase tracking-[0.1em] text-brand-red md:px-12 md:py-8 lg:px-14">
        <span>Chapinero · Bogotá</span>
        <span>Since &apos;26</span>
      </footer>
    </div>
  );
}
